<template>
  <div class="page image-bg">
    <div class="spacing"></div>
    <div class="wallet-bg image-bg">
      <div class="wallet-form">
        <div class="w-input">
          <input type="text" placeholder="请输入手机号" v-model="phoneNumber" />
        </div>
      </div>
      <div class="w-button" @click="submitAction">
        <img
    src="//download-cos.yofish.com/yofish-gongjushiyebu/20230301105827398-cpost-btn.png" alt="" />
      </div>
      <div class="palicy">
        <div class="agreement-btn" @click="isAggree = !isAggree">
          <img
          v-show="isAggree"
 src="//download-cos.yofish.com/yofish-gongjushiyebu/20230301111012768-cpost-checked.png" alt="" />
          <img
          v-show="!isAggree"
    src="//download-cos.yofish.com/yofish-gongjushiyebu/20230301110851250-cpost-check.png" alt="" />
        </div>
        <div class="agree-desc">
          <span class="qd">我已阅读并同意</span>
          <a href="//xmxccm.com/20230204/xy.html">个人信息保护政策（包含权限类别，隐私政策）、用户服务协议</a>
        </div>
      </div>
    </div>
    <div class="rule-bg">
      <img
      src="//download-cos.yofish.com/yofish-gongjushiyebu/2023030111153621-cpost-rule.png" alt="" />
    </div>
    <div class="ji-frame">
      <img
  src="//download-cos.yofish.com/yofish-gongjushiyebu/20230301112645623-cpost-intro.png" alt="" />
    </div>
    <div class="cpost-intro">
      <p>谨慎借贷，理性消费，额度、利率以审批为准，</p>
      <p>贷款仅用于日常消费用途，不得用于买房、买车、炒股及经营投资。</p>
    </div>
    <div class="adver-icon">
      <img
    src="//download-cos.yofish.com/yofish-gongjushiyebu/20230301112236352-adver-icon.png" alt="" />
    </div>
  </div>
</template>
<script>
import { getUploadClickAction, getPublicize } from '@/api/base';

export default {
  name: 'Cpost',
  data() {
    return {
      phoneNumber: '',
      isAggree: false,
    };
  },
  mounted() {
    document.title = '中邮消费金融';
    this.getPublicizeAction();
  },
  methods: {
    jumpUrl() {
      const { paramV } = this.$route.query;
      this.$router.push({
        path: '/leaflet/jump',
        query: {
          paramV,
        },
      });
    },
    async getPublicizeAction() {
      let res;
      const { query } = this.$route;
      // data = JSON.stringify(data);
      try {
        res = await getPublicize(query);
      } catch (e) {
        console.log(e);
        this.$toast({
          content: e.desc,
        });
      }
      if (res.code === 1) {
        // this.linkUrl = res?.results?.linkUrl;
        // this.channel = res?.results?.channel;
      }
    },
    async getUploadClickAction() {
      let res;
      const { phoneNumber } = this;
      const { paramV } = this.$route.query;
      console.log(paramV);
      this.visible1 = false;
      try {
        res = await getUploadClickAction({
          phone: phoneNumber,
          channel: paramV,
        });
      } catch (e) {
        console.log(e);
      }
      this.jumpUrl();
    },
    submitAction() {
      const myreg = /^(((13[0-9]{1})|(14[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(15[0-3]{1})|(15[4-9]{1})|(18[0-9]{1})|(199))+\d{8})$/;
      if (!this.phoneNumber) {
        this.$toast({ content: '请填写手机号!', duration: 2000 });
      } else if (this.phoneNumber.length < 11 || !myreg.test(this.phoneNumber)) {
        this.$toast({ content: '手机号填写有误,请重新输入!', duration: 2000 });
      } else if (!this.isAggree) {
        this.$toast({ content: '请阅读并勾选用户协议', duration: 2000 });
      } else {
        this.getUploadClickAction();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.image-bg {
  background-size: cover;
  background-repeat: no-repeat;
}
.page {
  width: 100%;
  max-width: 750px;
  height: 2467px;
  min-height: 100%;
  background-image:
  url('//download-cos.yofish.com/yofish-gongjushiyebu/20230315145910439-cpost-bg.png');
  margin: auto;
  position: relative;
}
.spacing {
  padding-top: 386px;
}
.wallet-bg {
  width: 594px;
  height: 518px;
  background-image:
  url('//download-cos.yofish.com/yofish-gongjushiyebu/20230301103535287-cpost-bag.png');
  margin: auto;
}
.wallet-form {
  width: 424px;
  margin-left: 100px;
  padding-top: 220px;
}
.w-input {
  width: 100%;
  height: 80px;
  background-color: #fff;
  border-radius: 105px;
}
input {
  width: 100%;
  outline: none;
  border: none;
  height: 80px;
  font-size: 24px;
  font-weight: 500;
  color: #333333;
  line-height: 70px;
  padding-top: 0;
  padding-bottom: 0;
  margin: 0;
  background-color: transparent;
  padding-left: 30px;
}
.w-button {
  width: 480px;
  // margin: 10px auto 0;
  margin-top: 10px;
  margin-left: 70px;
  img {
    width: 100%;
  }
}
.palicy {
  display: flex;
  width: 424px;
  margin-left: 100px;
  margin-top: -25px;
  .agreement-btn {
    width: 40px;
    position: relative;
    top: 2px;
    margin-right: 10px;
    img {
      width: 100%;
    }
  }
  .agree-desc,
  .agree-desc a {
    color: #fff;
    font-size: 20px;
    .qd {
      color: rgba(#fff, .7);
    }
  }
  .agree-desc a {
    text-decoration: none;
  }
}
.rule-bg {
  width: 670px;
  margin: 50px auto 0;
  img {
    width: 100%;
  }
}
.ji-frame {
  width: 670px;
  margin: 16px auto 0;
  img {
    width: 100%;
  }
}
.cpost-intro {
  text-align: center;
  font-size: 18px;
  color: #d3d4ff;
  margin-top: 66px;
}
.adver-icon {
  position: absolute;
  right: 0;
  width: 60px;
  bottom: 160px;
  img {
    width: 100%;
  }
}
</style>
